var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "observer",
    attrs: { tag: "form" },
    on: {
      submit: function ($event) {
        $event.preventDefault()
        return _vm.submit.apply(null, arguments)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ invalid }) {
          return [
            _c(
              "div",
              {
                staticClass: "modal-card",
                staticStyle: { "min-height": "750px" },
              },
              [
                _c("header", { staticClass: "modal-card-head" }, [
                  _c("p", { staticClass: "modal-card-title" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.editableGroup ? "Edit" : "Create") +
                        " group "
                    ),
                  ]),
                ]),
                _c(
                  "section",
                  { staticClass: "modal-card-body" },
                  [
                    _c("ValidationProvider", {
                      attrs: { rules: "required", slim: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors, valid }) {
                              return [
                                _c(
                                  "b-field",
                                  {
                                    attrs: {
                                      label: "Name",
                                      type: {
                                        "is-danger": errors[0],
                                        "is-success": valid,
                                      },
                                    },
                                  },
                                  [
                                    _c("b-input", {
                                      attrs: {
                                        name: "name",
                                        type: "text",
                                        required: "",
                                      },
                                      model: {
                                        value: _vm.newGroup.name,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.newGroup, "name", $$v)
                                        },
                                        expression: "newGroup.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c(
                      "b-field",
                      { attrs: { label: "Type" } },
                      [
                        _c(
                          "b-radio-button",
                          {
                            attrs: {
                              "native-value": "HUB",
                              type: "is-primary",
                              disabled: !_vm.isAdmin,
                            },
                            model: {
                              value: _vm.newGroup.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.newGroup, "type", $$v)
                              },
                              expression: "newGroup.type",
                            },
                          },
                          [
                            _c("b-icon", { attrs: { icon: "home" } }),
                            _c("span", [_vm._v("HUB")]),
                          ],
                          1
                        ),
                        _c(
                          "b-radio-button",
                          {
                            attrs: {
                              "native-value": "CUSTOMER",
                              type: "is-info",
                              disabled: !_vm.isAdmin,
                            },
                            model: {
                              value: _vm.newGroup.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.newGroup, "type", $$v)
                              },
                              expression: "newGroup.type",
                            },
                          },
                          [
                            _c("b-icon", { attrs: { icon: "handshake" } }),
                            _c("span", [_vm._v("CUSTOMER")]),
                          ],
                          1
                        ),
                        _c(
                          "b-radio-button",
                          {
                            attrs: {
                              "native-value": "END USER",
                              type: "is-purple",
                            },
                            model: {
                              value: _vm.newGroup.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.newGroup, "type", $$v)
                              },
                              expression: "newGroup.type",
                            },
                          },
                          [
                            _c("b-icon", { attrs: { icon: "user" } }),
                            _c("span", [_vm._v("END USER")]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.newGroup.type === "CUSTOMER"
                      ? _c(
                          "b-field",
                          { attrs: { label: "Customers" } },
                          [
                            _c("b-taginput", {
                              attrs: {
                                data: _vm.filteredCustomers,
                                field: "name",
                                autocomplete: "",
                                "open-on-focus": "",
                                disabled: _vm.newGroup.type !== "CUSTOMER",
                                icon: "search",
                              },
                              on: {
                                typing: _vm.getFilteredCustomersTags,
                                input: () => {
                                  _vm.filteredCustomers = _vm.rmIfExiste(
                                    _vm.customersAndEndusers,
                                    _vm.newGroup.customers,
                                    "id"
                                  )
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("strong", [
                                          _vm._v(_vm._s(props.option.id)),
                                        ]),
                                        _vm._v(
                                          " - " +
                                            _vm._s(props.option.name) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "tag",
                                    fn: function (props) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(props.tag.id) +
                                            " - " +
                                            _vm._s(props.tag.name) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.newGroup.customers,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newGroup, "customers", $$v)
                                },
                                expression: "newGroup.customers",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.newGroup.type === "END USER"
                      ? _c(
                          "b-field",
                          { attrs: { label: "End users" } },
                          [
                            _c("b-taginput", {
                              attrs: {
                                data: _vm.filteredEndusers,
                                field: "name",
                                autocomplete: "",
                                "open-on-focus": "",
                                disabled: _vm.newGroup.type !== "END USER",
                                icon: "search",
                              },
                              on: {
                                typing: _vm.getFilteredEndusersTags,
                                input: () => {
                                  _vm.filteredEndusers = _vm.rmIfExiste(
                                    _vm.endusers,
                                    _vm.newGroup.endusers,
                                    "name"
                                  )
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("strong", [
                                          _vm._v(_vm._s(props.option.id)),
                                        ]),
                                        _vm._v(
                                          " - " +
                                            _vm._s(props.option.name) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "tag",
                                    fn: function (props) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(props.tag.id) +
                                            " - " +
                                            _vm._s(props.tag.name) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.newGroup.endusers,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newGroup, "endusers", $$v)
                                },
                                expression: "newGroup.endusers",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.newGroup.type === "HUB"
                      ? _c(
                          "b-field",
                          { attrs: { label: "Plants" } },
                          [
                            _c("b-taginput", {
                              attrs: {
                                data: _vm.filteredPlants,
                                disabled: _vm.newGroup.type !== "HUB",
                                field: "name",
                                autocomplete: "",
                                "open-on-focus": "",
                                icon: "search",
                              },
                              on: {
                                typing: _vm.getFilteredPlantsTags,
                                input: () => {
                                  _vm.filteredPlants = _vm.rmIfExiste(
                                    _vm.plants,
                                    _vm.newGroup.plants,
                                    "name"
                                  )
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("strong", [
                                          _vm._v(_vm._s(props.option.id)),
                                        ]),
                                        _vm._v(
                                          " - " +
                                            _vm._s(props.option.name) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "tag",
                                    fn: function (props) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(props.tag.id) +
                                            " - " +
                                            _vm._s(props.tag.name) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.newGroup.plants,
                                callback: function ($$v) {
                                  _vm.$set(_vm.newGroup, "plants", $$v)
                                },
                                expression: "newGroup.plants",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-field",
                      { attrs: { label: "PowerBI" } },
                      [
                        _c("b-taginput", {
                          attrs: {
                            data: _vm.filteredPowerBis,
                            autocomplete: "",
                            "open-on-focus": "",
                            field: "name",
                            icon: "search",
                          },
                          on: {
                            typing: _vm.getFilteredPowerBis,
                            add: _vm.addAllRole,
                            input: () => {
                              _vm.filteredPowerBis = _vm.rmIfExiste(
                                _vm.allPowerBis,
                                _vm.newGroup.powerBis,
                                "id"
                              )
                            },
                          },
                          model: {
                            value: _vm.newGroup.powerBis,
                            callback: function ($$v) {
                              _vm.$set(_vm.newGroup, "powerBis", $$v)
                            },
                            expression: "newGroup.powerBis",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._l(
                      _vm.newGroup.powerBis.filter(
                        (el) => el.allRoles.length !== 0
                      ),
                      function (item) {
                        return _c(
                          "b-field",
                          { key: item.id, attrs: { label: item.name } },
                          [
                            _c("b-taginput", {
                              attrs: {
                                data: _vm.rmIfExiste(
                                  item.allRoles,
                                  item.roles,
                                  "id"
                                ),
                                autocomplete: "",
                                "open-on-focus": "",
                                readonly: "",
                                field: "role",
                                icon: "search",
                              },
                              model: {
                                value: item.roles,
                                callback: function ($$v) {
                                  _vm.$set(item, "roles", $$v)
                                },
                                expression: "item.roles",
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                  ],
                  2
                ),
                _c("footer", { staticClass: "modal-card-foot" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-info is-fullwidth",
                      class: { "is-loading": _vm.isSubmitting },
                      attrs: { disabled: invalid, ype: "submit" },
                    },
                    [_vm._v(" Submit ")]
                  ),
                ]),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }